import { render, staticRenderFns } from "./Events.vue?vue&type=template&id=77d48e9a&scoped=true&"
import script from "./Events.vue?vue&type=script&lang=ts&"
export * from "./Events.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d48e9a",
  null
  
)

export default component.exports